/* STEP 3 · rule 6 (B-6b) — the lead sheet's named "statement lines": what the statements add to the head's line beyond the
   balances of its accounts (the period's profit closed into retained earnings 2106, OCI in its reserve, goodwill moved between
   1104 and 1111). The server sends them with the account columns (py_final, cy_unadjusted, adjustments, cy_final, movement) and
   counts them in the totals, so the lead sheet's total is the statement line (lead sheet = Scoping = FS). The label comes from
   the server in EN and AR (label_en / label_ar); nothing is computed here. */
import React from "react";
import Amount from "@/components/Amount";
import { asArray } from "@/lib/asArray";

export default function LeadStatementLines({ lines, lang }) {
  return asArray(lines).map((s) => (
    <tr key={s.kind} className="bg-slate-50/60 italic dark:bg-slate-900/30" data-testid={`lead-statement-line-${s.kind}`}>
      <td className="px-2 py-1 font-mono text-muted-foreground">—</td>
      <td className="px-2 py-1">{(lang === "ar" ? s.label_ar : s.label_en) || s.label_en}</td>
      <td className="px-2 py-1 text-end">{s.py_final == null ? "—" : <Amount value={s.py_final} />}</td>
      <td className="px-2 py-1 text-end"><Amount value={s.cy_unadjusted} /></td>
      <td className="px-2 py-1 text-end"><Amount value={s.adjustments} /></td>
      <td className="px-2 py-1 text-end"><Amount value={s.cy_final} /></td>
      <td className="px-2 py-1 text-end"><Amount value={s.movement} /></td>
      <td colSpan={3} />
    </tr>
  ));
}
